var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "kpi-d-edit" },
    _vm._l(_vm.chartData, function (kpiDData, kpiDIndex) {
      return _c("div", { key: kpiDIndex, staticClass: "flex-row flex-1" }, [
        _c("div", { staticClass: "flex-col flex-1 mr-2 ml-1" }, [
          _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
            _vm._v(" " + _vm._s(kpiDData.kpiNameLabel) + " "),
          ]),
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-align-center mt-2 mr-2" },
            [_vm._v(" " + _vm._s(kpiDData.typeDLabel1) + " ")]
          ),
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-align-center mt-2 mr-2" },
            [_vm._v(" " + _vm._s(kpiDData.typeDLabel2) + " ")]
          ),
        ]),
        _c("div", { staticClass: "flex-col flex-2" }, [
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-align-center chart-title" },
            [_vm._v(" " + _vm._s(kpiDData.kpiName) + " ")]
          ),
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-justify-center mt-2" },
            [
              _c(
                "div",
                { staticClass: "flex-col flex-4 box-side-label pr-1 ml-1" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("struggleWithUnambitiousTargets")) + " "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 ml-1 redBox",
                  on: {
                    click: function ($event) {
                      _vm.performanceBlock.isRedMarked =
                        !_vm.performanceBlock.isRedMarked
                    },
                  },
                },
                [
                  _vm.performanceBlock.isRedMarked
                    ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 yellowBox",
                  on: {
                    click: function ($event) {
                      _vm.performanceBlock.isYellowMarked =
                        !_vm.performanceBlock.isYellowMarked
                    },
                  },
                },
                [
                  _vm.performanceBlock.isYellowMarked
                    ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 darkGreenBox",
                  on: {
                    click: function ($event) {
                      _vm.performanceBlock.isDarkGreenMarked =
                        !_vm.performanceBlock.isDarkGreenMarked
                    },
                  },
                },
                [
                  _vm.performanceBlock.isDarkGreenMarked
                    ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 lightGreenBox",
                  on: {
                    click: function ($event) {
                      _vm.performanceBlock.isLightGreenMarked =
                        !_vm.performanceBlock.isLightGreenMarked
                    },
                  },
                },
                [
                  _vm.performanceBlock.isLightGreenMarked
                    ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 mr-2 greenBox",
                  on: {
                    click: function ($event) {
                      _vm.performanceBlock.isGreenMarked =
                        !_vm.performanceBlock.isGreenMarked
                    },
                  },
                },
                [
                  _vm.performanceBlock.isGreenMarked
                    ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "flex-col flex-4 flex-justify-center mr-5 pr-5 box-side-label",
                },
                [_vm._v(" " + _vm._s(_vm.$t("exceedAmbitiousTarget")) + " ")]
              ),
            ]
          ),
          _c("div", { staticClass: "flex-row flex-1 mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex-col flex-4 flex-align-center pt-1 pr-1 ml-1 box-side-label",
              },
              [_vm._v(" " + _vm._s(_vm.$t("underMaintained")) + " ")]
            ),
            _c(
              "div",
              {
                staticClass: "flex-col flex-2 ml-1 redBox",
                on: {
                  click: function ($event) {
                    _vm.riskBlock.isRedMarked = !_vm.riskBlock.isRedMarked
                  },
                },
              },
              [
                _vm.riskBlock.isRedMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex-col flex-2 yellowBox",
                on: {
                  click: function ($event) {
                    _vm.riskBlock.isYellowMarked = !_vm.riskBlock.isYellowMarked
                  },
                },
              },
              [
                _vm.riskBlock.isYellowMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex-col flex-2 darkGreenBox",
                on: {
                  click: function ($event) {
                    _vm.riskBlock.isDarkGreenMarked =
                      !_vm.riskBlock.isDarkGreenMarked
                  },
                },
              },
              [
                _vm.riskBlock.isDarkGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex-col flex-2 lightGreenBox",
                on: {
                  click: function ($event) {
                    _vm.riskBlock.isLightGreenMarked =
                      !_vm.riskBlock.isLightGreenMarked
                  },
                },
              },
              [
                _vm.riskBlock.isLightGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex-col flex-2 mr-2 greenBox",
                on: {
                  click: function ($event) {
                    _vm.riskBlock.isGreenMarked = !_vm.riskBlock.isGreenMarked
                  },
                },
              },
              [
                _vm.riskBlock.isGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex-col flex-4 flex-justify-center pt-1 mr-5 pr-5 box-side-label",
              },
              [_vm._v(" " + _vm._s(_vm.$t("wellMaintained")) + " ")]
            ),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }